export const IS_REVOKED_RP = 2;
